export interface ConnectionState {
  connection: {
    ALM: { connectioName: string; connectionType: string; meta: {} }[];
    LLM: any[];
    LLM_PARSER:any[];
    FILE: any[];
    DATABASE: any[];
  };
  loading: boolean;
  error: string | null;
}

export const initialState: ConnectionState = {
  connection: {
    ALM: [],
    LLM: [],
    LLM_PARSER: [],
    FILE: [],
    DATABASE: [],
  },
  loading: false,
  error: null,
};
